module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm5_m_en.295ec65f1b0efd38890ae69d4814f4fa.png";